import React, { useState, useCallback, useRef, useMemo } from 'react';
import { useScreenSize } from '../../../../../utils/media-query';
import { PopupForm, PopupGrid } from '../../../../script/components/popup/popup';
import { FormBool, FormDate, FormGrid, FormMemo, FormNumb, FormText } from '../../../../script/components/form/form-item';
import { GroupItem } from 'devextreme-react/cjs/form';
import { ScrollGrid } from '../../../../script/components/data-grid/data-grid-body/grid-bodys';
import { BoolCol, CommCol, DeciCol } from '../../../../script/components/data-grid/data-grid-column/grid-column';
import { fwUtil } from '../../../../script/util';
import { set } from '../../../../../api/set';

const defaultData = {
    work_numb: '',
    item_code: '',
    rout_numb: '',
    rout_seri: '',
    item_name: '',
    rout_name: '',
    last_rout: false,
    stoc_loca: '사내창고',
    equi_numb: '',
    equi_name: '',
    cycl_time: '',
    work_date: fwUtil.date.getsText.date(),
    work_qtys: 0,
    infe_qtys: 0,
    work_gubu: '',
    work_name: '',
    prod_memo: '',    
};

const setProd = set.mes.mfg.prod;

export function ProductsRegiInsert(props) {
    const {
        refresh,
        mainGrid,
        insertApi,
        visible, hiding
    } = props;

    const { isXSmall, isSmall, isLarge } = useScreenSize();
    const [loading, setLoading] = useState(false);
    // 데이터
    const [data, setData] = useState(defaultData);
    const dataUpdate = useCallback((e) => setData(e), [setData]);
    // 그리드
    const routGridRef = useRef(null);
    const [routData, setRoutData] = useState([]);
    const routGridUpdate = useCallback((e) => setRoutData(e), []);
    const routKeyExpr = useMemo(() => ['work_numb', 'item_code', 'rout_numb'], []);
    const equiGridRef = useRef(null);
    const [equiData, setEquiData] = useState([]);
    const equiGridUpdate = useCallback((e) => setEquiData(e), []);
    const equiKeyExpr = 'main_numb';
    // 그리드 팝업
    const [routPopupVisible, setRoutPopupVisible] = useState(false);
    const routPopupHiding = useCallback(() => setRoutPopupVisible(false), []);
    const [equiPopupVisible, setEquiPopupVisible] = useState(false);
    const equiPopupHiding = useCallback(() => setEquiPopupVisible(false), []);
    // 팝업 조회
    const routHandleSearch = useCallback(async () => {
        const sendData = { workNumb: data.work_numb, itemCode: data.item_code }
        const res = await setProd.rout(sendData);
        routGridUpdate(res);
    }, [data, routGridUpdate]);

    const equiHandleSearch = useCallback(async () => {
        const sendData = { equiNumb: '' }
        const res = await setProd.equi(sendData);
        equiGridUpdate(res);
    }, [equiGridUpdate]);

    // 열릴 때
    const onShowing = useCallback(async () => {
        const selectedRowData = fwUtil.grid.get.sData(mainGrid);
        if (!selectedRowData) {
            fwUtil.aler.toast.s1Erro();
            hiding();
        } else {
            const updatedData = {
                ...defaultData,
                work_numb: selectedRowData.work_numb || '',
                item_code: selectedRowData.item_code || '',
                item_name: selectedRowData.item_name || '',
                orde_qtys: selectedRowData.orde_qtys || 0,
                work_qtys: selectedRowData.orde_qtys || 0,
            };

            dataUpdate(updatedData);
        }
    }, [hiding, mainGrid, dataUpdate]);

    // 수정
    const updateField = (field) => (value) => {
        if (!data) return;

        dataUpdate({ ...data, [field]: value });
    };

    // 제출
    const onSubmit = useCallback(async () => {
        setLoading(true);
        const postData = {
            workNumb: data.work_numb || '',
            itemCode: data.item_code || '',
            routNumb: data.rout_numb || '',
            routSeri: data.rout_seri || '',
            itemName: data.item_name || '',
            routName: data.rout_name || '',
            lastRout: data.last_rout || false,
            stocLoca: data.stoc_loca || '',                        
            equiNumb: data.equi_numb || '',
            equiName: data.equi_name || '',
            cyclTime: data.cycl_time || '',
            workDate: data.work_date || fwUtil.date.getsText.date(),
            workQtys: parseFloat(data.work_qtys) || 0,
            infeQtys: parseFloat(data.infe_qtys) || 0,
            workGubu: data.work_gubu || '',
            workName: data.work_name || '',
            prodMemo: data.prod_memo || '',    
        };

        await fwUtil.apis.action(insertApi, postData, refresh, hiding);
        setLoading(false);
    }, [data, insertApi, refresh, hiding]);

    // 팝업 열릴 때
    const routPopupOnShowing = useCallback(() => {
        routHandleSearch();
    }, [routHandleSearch]);

    const equiPopupOnShowing = useCallback(() => {
        equiHandleSearch();
    }, [equiHandleSearch]);

    // 팝업 더블 클릭
    const routOnRowDblClick = useCallback((e) => {
        dataUpdate({ ...data, rout_numb: e.data.rout_numb, rout_name: e.data.rout_name, last_rout: e.data.last_rout, work_gubu: e.data.work_gubu, orde_qtys: e.data.work_qtys });
        routPopupHiding();
    }, [data, dataUpdate, routPopupHiding]);

    const equiOnRowDblClick = useCallback((e) => {
        dataUpdate({ ...data, equi_numb: e.data.main_numb, equi_name: e.data.equi_name });
        equiPopupHiding();
    }, [data, dataUpdate, equiPopupHiding]);

    const routGrid = useMemo(() => {
        return (
            <ScrollGrid
                title={'공정'}
                role={'목록'}
                gridDataSource={routData}
                gridRef={routGridRef}
                mainKey={routKeyExpr}
                width={isXSmall ? 300 : isSmall ? 550 : 860}
                height={600}
                hideColumnChooser
                onRowDblClick={routOnRowDblClick}
                selection={'single'}
            >
                {CommCol({ dataField: "work_numb", caption: "작업지시번호" })}
                {CommCol({ dataField: "item_code", caption: "제품번호" })}
                {CommCol({ dataField: "rout_numb", caption: "공정번호" })}
                {CommCol({ dataField: "rout_name", caption: "공정명" })}
                {DeciCol({ dataField: "work_qtys", caption: "지시수량" })}
                {BoolCol({ dataField: "last_rout", caption: "완료공정" })}
                {CommCol({ dataField: "work_gubu", caption: "작업구분" })}
            </ScrollGrid>
        )
        //{ DeciCol({ dataField: "comp_qtys", caption: "완료수량" }) }
        //{ DeciCol({ dataField: "infe_qtys", caption: "불량수량" }) }
}, [routData, routGridRef, routKeyExpr, routOnRowDblClick, isXSmall, isSmall]);

    const equiGrid = useMemo(() => {
        return (
            <ScrollGrid
                title={'설비'}
                role={'목록'}
                gridDataSource={equiData}
                gridRef={equiGridRef}
                mainKey={equiKeyExpr}
                width={isXSmall ? 300 : isSmall ? 550 : 860}
                height={600}
                hideColumnChooser
                onRowDblClick={equiOnRowDblClick}
                selection={'single'}
            >
                {CommCol({ dataField: "main_numb", caption: "관리번호" })}
                {CommCol({ dataField: "equi_numb", caption: "설비번호" })}
                {CommCol({ dataField: "equi_name", caption: "설비명" })}
                {CommCol({ dataField: "equi_type", caption: "규격/형식" })}

                
            </ScrollGrid>
        )
    }, [equiData, equiGridRef, equiKeyExpr, equiOnRowDblClick, isXSmall, isSmall]);

    return (
        <>
            <PopupGrid
                title={'공정 선택'}
                visible={routPopupVisible}
                shown={routPopupOnShowing}
                hiding={routPopupHiding}
            >
                {routGrid}
            </PopupGrid>
            <PopupGrid
                title={'설비 선택'}
                visible={equiPopupVisible}
                shown={equiPopupOnShowing}
                hiding={equiPopupHiding}
            >
                {equiGrid}
            </PopupGrid>
            <PopupForm
                title={'작업일보 등록'}
                type={'등록'}
                loading={loading}
                visible={visible}
                showing={onShowing}
                hiding={hiding}
                onSubmit={onSubmit}
                width={isXSmall || isSmall ? "100%" : 1200}
            >
                <GroupItem colCount={isXSmall ? 1 : isLarge ? 4 : 2 }>
                    <GroupItem colCount={isXSmall ? 1 : isLarge ? 4 : 2 } colSpan={isXSmall ? 1 : isLarge ? 4 : 2 }>
                        {FormText({ value: data.work_numb, onValueChange: updateField('work_numb'), label: '작업지시번호', disabled: true, required: true })}
                        {FormText({ value: data.item_code, onValueChange: updateField('item_code'), label: '제품번호', disabled: true, required: true })}
                        {FormText({ value: data.item_name, onValueChange: updateField('item_name'), label: '제 품 명', disabled: true, required: true })}
                        {FormText({ value: data.rout_seri, onValueChange: updateField('rout_seri'), label: '일보순번[자동입력]', disabled: true })}
                    </GroupItem>
                    {FormGrid({ value: data.rout_numb, onValueChange: updateField('rout_numb'), onClick: () => setRoutPopupVisible(true), label: '공정번호', required: true })}
                    {FormText({ value: data.rout_name, onValueChange: updateField('rout_name'), label: '공정명', disabled: true })}
                    {FormNumb({ value: data.orde_qtys, onValueChange: updateField('orde_qtys'), label: '지시수량', disabled: true })}
                    {FormBool({ value: data.last_rout, onValueChange: updateField('last_rout'), label: '완료공정', disabled: true })}
                    {FormText({ value: data.work_gubu, onValueChange: updateField('work_gubu'), label: '작업구분', disabled: true })}    
                    {FormGrid({ value: data.equi_numb, onValueChange: updateField('equi_numb'), onClick: () => setEquiPopupVisible(true), label: '설비번호' })}
                    {FormText({ value: data.equi_name, onValueChange: updateField('equi_name'), label: '설비명', disabled: true })}
                    {FormNumb({ value: data.cycl_time, onValueChange: updateField('cycl_time'), label: '설비재공시간', length: [2, 0] })}
                    {FormText({ value: data.stoc_loca, onValueChange: updateField('stoc_loca'), label: '저장위치', required: true })}
                    {FormText({ value: data.work_name, onValueChange: updateField('work_name'), label: '작업자', maxLength: 20 })}
                    {FormNumb({ value: data.work_qtys, onValueChange: updateField('work_qtys'), label: '작업수량', length: [10, 2] })}
                    {FormNumb({ value: data.infe_qtys, onValueChange: updateField('infe_qtys'), label: '불량수량', length: [10, 2] })}        
                    {FormDate({ value: data.work_date, onValueChange: updateField('work_date'), label: '작업일자' })}                
                </GroupItem>
                {FormMemo({ value: data.prod_memo, onValueChange: updateField('prod_memo'), label: '비고' })}
            </PopupForm>
        </>
    );
}

